// Frontend API wrapper for the public Team Visualization page (PRODOPSAI-528).
// Endpoint paths are passed WITHOUT the `/api` prefix — the `api` wrapper adds
// it (CLAUDE.md). Read-only, all authenticated users.

import { api } from '@/lib/api';
import type { IApiResponse, IPublicTeamTreeResponse } from '@skystone/shared';

export const teamVisualizationApi = {
  /** Fetch the entire Team -> Role -> Person tree in one round-trip. */
  getTeamOverview: async (): Promise<IPublicTeamTreeResponse> => {
    const result = await api.get<IApiResponse<IPublicTeamTreeResponse>>(
      '/team-visualization/overview',
    );
    return result.data;
  },
};
